import { actions } from './actions'

const initialState = {
  paginaOkTemplate: {
    data: null,
    loading: false,
    error: '',
  },
  seccionTemplate: {
    data: null,
    loading: false,
    error: '',
  },
  mensajeWhatapp: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function paginaOkTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_REQUESTED:
      return { ...state, paginaOkTemplate: { ...state.paginaOkTemplate, loading: true } }
    case actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        paginaOkTemplate: { ...state.paginaOkTemplate, data: action.payload, loading: false },
      }
    case actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_FILED:
      return {
        ...state,
        paginaOkTemplate: { ...state.paginaOkTemplate, loading: false, error: action.error },
      }
    case actions.PAGINA_OK_TEMPLATE_UPDATE_REQUESTED:
      return {
        ...state,
        paginaOkTemplate: { ...state.paginaOkTemplate, loading: true, error: '' },
      }
    case actions.PAGINA_OK_TEMPLATE_UPDATE_SUCCEEDED:
      return {
        ...state,
        paginaOkTemplate: {
          ...state.paginaOkTemplate,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.PAGINA_OK_TEMPLATE_UPDATE_FILED:
      return {
        ...state,
        paginaOkTemplate: { ...state.paginaOkTemplate, loading: false, error: action.error },
      }
    case actions.SECCION_TEMPLATE_BY_ID_LOAD_REQUESTED:
      return { ...state, seccionTemplate: { ...state.seccionTemplate, loading: true } }
    case actions.SECCION_TEMPLATE_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        seccionTemplate: { ...state.seccionTemplate, data: action.payload, loading: false },
      }
    case actions.SECCION_TEMPLATE_BY_ID_LOAD_FILED:
      return {
        ...state,
        seccionTemplate: { ...state.seccionTemplate, loading: false, error: action.error },
      }
    case actions.SECCION_TEMPLATE_UPDATE_REQUESTED:
      return {
        ...state,
        seccionTemplate: { ...state.seccionTemplate, loading: true, error: '' },
      }
    case actions.SECCION_TEMPLATE_UPDATE_SUCCEEDED:
      return {
        ...state,
        seccionTemplate: {
          ...state.seccionTemplate,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.SECCION_TEMPLATE_UPDATE_FILED:
      return {
        ...state,
        seccionTemplate: { ...state.seccionTemplate, loading: false, error: action.error },
      }

    case actions.SECCION_MENSAJE_WHATSAPP_REQUESTED:
      return { ...state, mensajeWhatapp: { ...state.mensajeWhatapp, loading: true } }
    case actions.SECCION_MENSAJE_WHATSAPP_SUCCEEDED:
      return {
        ...state,
        mensajeWhatapp: { ...state.mensajeWhatapp, data: action.payload, loading: false },
      }
    case actions.SECCION_MENSAJE_WHATSAPP_FAILED:
      return {
        ...state,
        mensajeWhatapp: { ...state.mensajeWhatapp, loading: false, error: action.error },
      }

    default:
      return state
  }
}
